// removed by extract-text-webpack-plugin
module.exports = {"Nav":"src-components-ProgramOverview-Nav----Nav-module---Nav---39qs7","active":"src-components-ProgramOverview-Nav----Nav-module---active---37KUX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProgramOverview/Nav/Nav.module.scss
// module id = 738
// module chunks = 184655746423024